import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { HistoryPageRoutingModule } from "./history-routing.module";
import { HistoryPage } from "./history.page";
import { TranslateModule } from "@ngx-translate/core";
import { LogoModule } from "src/app/components/logo/logo.module";
import { IsReportFilledModule } from "src/app/pipes/is-report-filled/is-report-filled.module";
import { ReportsWithQuestionModule } from "src/app/pipes/reports-with-question/reports-with-question.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HistoryPageRoutingModule,
    TranslateModule,
    LogoModule,
    IsReportFilledModule,
    ReportsWithQuestionModule,
  ],
  declarations: [HistoryPage],
})
export class HistoryPageModule {}
